import { Helmet } from "react-helmet-async";

const DEFAULTS = {
  siteName: "HAEVN",
  title: "HAEVN — A Matching Network for Singles",
  description:
    "HAEVN is a matching network that connects singles based on 80%+ compatibility. No swiping. No searching. Just qualified matches.",
  image: "/og-image.jpg",
  type: "website",
};

export default function SEO({
  title,
  description,
  path = "",
  image,
  type,
}) {
  const pageTitle = title
    ? `${title} | ${DEFAULTS.siteName}`
    : DEFAULTS.title;
  const pageDescription = description || DEFAULTS.description;
  const pageImage = image || DEFAULTS.image;
  const pageType = type || DEFAULTS.type;
  const canonical = `https://www.haevn.co${path}`;

  return (
    <Helmet>
      <title>{pageTitle}</title>
      <meta name="description" content={pageDescription} />
      <link rel="canonical" href={canonical} />

      {/* Open Graph */}
      <meta property="og:title" content={pageTitle} />
      <meta property="og:description" content={pageDescription} />
      <meta property="og:image" content={pageImage} />
      <meta property="og:type" content={pageType} />
      <meta property="og:url" content={canonical} />
      <meta property="og:site_name" content={DEFAULTS.siteName} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={pageTitle} />
      <meta name="twitter:description" content={pageDescription} />
      <meta name="twitter:image" content={pageImage} />
    </Helmet>
  );
}
